import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.matterjs.core.Engine
import com.github.chosamuel.matterjs.core.Matter
import com.github.chosamuel.matterjs.jsObject
import org.w3c.dom.HTMLElement
import kotlinx.browser.window

fun Application.useMouseConstraint(en: Engine){
    val m = Matter.Mouse.create(this.canvas as HTMLElement)
    val mouseConstraint = Matter.MouseConstraint.create(en,
        jsObject{
            mouse = m
            pixelRatio = window.devicePixelRatio
        })
    Matter.Composite.add(en.world,mouseConstraint)
}